import React, { useEffect, useState } from "react";
import { getOrderByID } from "../../../services/orderService";
import { Order } from "../../../interfaces/order";
import { useLocation } from "react-router-dom";
import CandidateForm from "../../../components/questionnaires/CandidateForm";
import { getSimpleClient } from "../../../services/clientService";
import { getReferenceOrderByOrderID } from "../../../services/referenceOrderService";

const CandidateScreeningQuestionnaire = () => {
  const [order, setOrder] = useState<Order | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { orderID, orderFormID } = location.state || {};
  const [successMessage, setSuccessMessage] = useState("");
  const [fiveYears, setFiveYears] = useState(false);

  useEffect(() => {
    const loadOrder = async () => {
      try {
        const order = await getOrderByID(orderID);
        setOrder(order);

        const client = await getSimpleClient(order.clientID);
        const referenceOrder = await getReferenceOrderByOrderID(order.orderID);

        const fiveYears =
          referenceOrder.years <= 5 && client.denomination === "ACNA";
        setFiveYears(fiveYears);
      } catch (error) {
        console.error("Error fetching candidate, order or orderForm:", error);
      } finally {
        setLoading(false);
      }
    };
    loadOrder();
  }, [orderID]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <div className="content-container">
      <div className="form-header-container">
        <h1>
          {order?.candidateFirstName} {order?.candidateLastName}
        </h1>
        <div className="page-items-container"></div>
      </div>
      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          <div className="text-form-header">CANDIDATE QUESTIONNAIRE</div>
          {order && (
            <CandidateForm
              order={order}
              clientID={order?.clientID ? order.clientID : 0}
              orderFormID={orderFormID}
              isReadOnly={false}
              isEditing={false}
              fiveYear={fiveYears}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CandidateScreeningQuestionnaire;
